// extracted by mini-css-extract-plugin
export default {"container":"nROkC","supporters-container":"eHoXy","supporter-avatar-container":"QE8gr","supporter-avatar":"KMNQW"};